








































































































































































































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import { validCPF } from '@/helpers/validCPF';
import { validEmail } from '@/helpers/validEmail';
import { IBusinessUnit } from '@/interfaces/business-units';
import IClient from '@/interfaces/client';
import IDoctor from '@/interfaces/doctor';
import { LoginUnidadesParmDTO, LoginUsuarioParmDTO, UsuarioCpfCrmExistenteException } from '@/interfaces/user';
import { getBusinessUnitsUser } from '@/services/business-units';
import * as doctorService from '@/services/doctors';
import { getDoctors } from '@/services/doctors';
import { getLocalUser } from '@/services/session-data';
import * as service from '@/services/users';
import { ACCESS_TYPE_CLIENT, ACCESS_TYPE_EMEDE, USER_TYPE_DOCTOR, USER_TYPE_OTHER } from '@/settings/consts/users';
import UserActivationForm from '@/views/users/screens/activation-form.vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import UserActivationHist from './user-activation-hist.vue';

@Component({
  components: {
    PermissionAuth,
    UiSelectDoctor,
    UiAutocompleClientsSubsidiaries,
    UserActivationForm,
    UserActivationHist
  }
})
export default class UserForm extends BaseComponent {
  @Prop()
  public id: any;

  @Prop({ default: false })
  public isEdit: boolean;

  @Prop({ default: false })
  public alterUnitOnly: boolean;

  formOpen = false;

  public form: any = {
    valid: false,
    rules: {
      userType: [(v) => !!v || 'Selecione um tipo de usuário'],
      accessType: [(v) => !!v || 'Selecione um tipo de acesso'],
      nome: [(v) => !!v || 'Digite o nome'],
      celular: [(v) => !!v || 'Digite o celular'],
      email: [(v) => !!v || 'Digite o e-mail', (v) => !v || validEmail(v) || 'Digite um e-mail válido.'],
      cpf: [(v) => !!v || 'Digite o CPF', (v) => !v || validCPF(v) || 'Digite um CPF válido.'],
      doctor: [(v) => (!!v && !!v.id) || 'Selecione um médico'],
      clientUnits: [
        (v) => {
          return (!!v && !!v.length) || 'Selecione pelo menos uma unidade';
        }
      ],
      units: [(v) => (!!v && !!v.length) || 'Selecione pelo menos uma unidade'],
      profile: [(v) => !!v || 'Selecione um perfil']
    }
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public userTypeDoctor: Boolean = false;
  public item: any = {
    nome: null,
    tipoLogin: USER_TYPE_DOCTOR,
    tipoAcesso: ACCESS_TYPE_CLIENT,
    ativo: true,
    idsUnidadesClientes: [],
    idsEmpresas: [],
    aceitaNotificacaoEmail: true,
    aceitaNotificacaoWhatsapp: true,
    cdsAreasGeograficas: [],
    celValidado: false,
  };
  public units: IBusinessUnit[] = [];
  public userTypes = [];
  public userTypesLoading = false;
  public profiles: any[] = [];
  public profilesLoading = false;
  public doctorLoading: boolean = false;
  public doctors: IDoctor[] = [];
  public selectedDoctor: IDoctor = null;
  public clients: IClient[] = null;

  USER_TYPE_DOCTOR = USER_TYPE_DOCTOR;
  USER_TYPE_OTHER = USER_TYPE_OTHER;

  public accessTypes = {
    emede: ACCESS_TYPE_EMEDE,
    client: ACCESS_TYPE_CLIENT
  };
  leaders = [];
  leadersLoading = false;
  geoAreas = [];
  geoAreasLoading = false;
  planningCycleTypes = [
    {id: 'S', nome: 'Semanal'},
    {id: 'Q', nome: 'Quinzenal'},
    {id: 'M', nome: 'Mensal'},
  ]

  private showActivationModal: boolean = false;
  private activationUserId: String = null;
  private activationSaved: boolean = false;

  showHist = false;

  

  @Watch('id', { immediate: true })
  public onIdChanges(id: any) {
    if (!id) {
      this.formOpen = true;
      this.getProfiles();
      return;
    }

    this.loader.start('Carregando item...');
    service.getUser(id).subscribe(
      (data) => {
        this.item = data;
        this.formOpen = true;
        this.loader.stop();
        this.getProfiles();
        this.loadLeaders();
        this.loadGeoAreas();

        if (this.item.tipoLogin === USER_TYPE_DOCTOR) {
          setTimeout(() => {
            if (this.item.idMedico) {
              this.doctorLoading = true;
              this.addSubsc(
                doctorService.getDoctor(this.item.idMedico).subscribe(
                  (doctor) => {
                    this.selectedDoctor = doctor;
                    this.onChangeDoctor(this.selectedDoctor);
                    this.doctorLoading = false;
                  },
                  (error) => {
                    this.doctorLoading = false;
                  }
                )
              );
            } else {
              this.selectedDoctor = null;
            }
          }, 200);
        }
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar o item', 'error');
      }
    );
  }

  @Watch('item.tipoAcesso')
  public onChangeAccessType(val: string): void {
    this.getProfiles();

    if (val === ACCESS_TYPE_EMEDE) {
      this.item.idsUnidadesClientes = [];
    } else {
      this.item.idsEmpresas = [];
    }
  }

  public onChangeUserType(): void {
    this.item.idsUnidadesClientes = [];
    if (this.item.tipoLogin === USER_TYPE_DOCTOR) {
      this.clients = [];
      this.userTypeDoctor = true;
    } else {
      this.clients = null;
      this.userTypeDoctor = false;
    }
    this.selectedDoctor = null;
    this.form.render;
  }

  public onChangeDoctor(val): void {
    if (!this.item.id) {
      this.item.idsUnidadesClientes = [];
    }

    if (!!val) {
      this.clients = val.unidadesCliente.reduce((clients, unitClient) => {
        const clientIndex = clients.findIndex((item) => item.id === unitClient.cliente.id);
        if (clientIndex !== -1) {
          clients[clientIndex].unidades.push(unitClient);
        } else {
          const client = unitClient.cliente;
          client.unidades = [unitClient];
          clients.push(client);
        }

        return clients;
      }, []);
    } else {
      this.clients = null;
    }
  }

  public beforeMount(): void {
    this.getUserTypes();
    this.getDoctors();
    this.getUnits();
  }

  public saveItem(cienteCpf: boolean): void {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }

    if (this.item.tipoLogin === USER_TYPE_DOCTOR) {
      this.item.idMedico = this.selectedDoctor.id;
      // this.item.email = this.selectedDoctor.email;
      this.item.crm = this.selectedDoctor.crm;
      this.item.crmUF = this.selectedDoctor.crmUF;
    }

    if (!this.isEmede()) {
      this.item.tipoAcesso = ACCESS_TYPE_CLIENT;
    }

    this.loader.start('Salvando registro...');

    let form = this.item;
    let parm = new LoginUsuarioParmDTO();
    parm.id = this.item.id ? Number(this.item.id) : null;
    parm.nome = form.nome;
    parm.email = form.email;
    parm.cpf = form.cpf;
    parm.cienteCpfExiste = cienteCpf;
    parm.crm = form.crm;
    parm.crmUF = form.crmUF;
    parm.telefone = form.telefone;
    parm.celular = form.celular;
    parm.ativo = form.ativo;
    parm.idPerfil = form.idPerfil;
    parm.idsUnidadesEmpresariais = form.idsEmpresas;
    parm.idsUnidadesCliente = form.idsUnidadesClientes;
    parm.tipoAcesso = form.tipoAcesso;
    parm.tipoLogin = form.tipoLogin;
    parm.aceitaNotificacaoEmail = form.aceitaNotificacaoEmail;
    parm.aceitaNotificacaoWhatsapp = form.aceitaNotificacaoWhatsapp;
    parm.cdsAreasGeograficas = form.cdsAreasGeograficas ? form.cdsAreasGeograficas.filter((cd) => this.geoAreas.map((a) => a.id).includes(cd)) : null;
    parm.tipoCicloPlanejamento = form.tipoCicloPlanejamento;
    if (!this.isLeadersChoiceAvailable()) {
      parm.idsLideres = [];
    } else if(!!form.idsLideres && !!this.leaders && !!this.leaders.length){
      parm.idsLideres = form.idsLideres.filter(id => this.leaders.findIndex(l => l.id == id) != -1);
    } else {
      parm.idsLideres = [];
    }

    const onError = (error) => {
      this.loader.stop();
      let ex = this.parseJsonExceptionTypeOrNull(
        error,
        'UsuarioCpfCrmExistenteException',
        new UsuarioCpfCrmExistenteException()
      ) as UsuarioCpfCrmExistenteException;
      if (ex) {
        let msg = `Já existe um usuário cadastrado com o `;
        msg += ex.validacaoCrm ? `CRM informado (${ex.crm}).` : `CPF informado (${ex.cpf}).`;
        msg += `<br>Usuário: <strong>${ex.nomeUsuario}</strong>`;
        msg += `<br>Deseja aplicar as alterações no cadastro de ${ex.nomeUsuario}?`;
        this.dialog.show(
          'alert',
          'Atenção, usuário já cadastrado!',
          null,
          'Alterar usuário encontrado',
          () => {
            this.saveItem(true);
          },
          'Cancelar',
          '',
          msg,
          '500px',
          'orange white--text',
          'red white--text',
          true
        );
        return;
      }
      this.showToastApiError(error);
    };

    if (!this.item.id) {
      service.saveUser(parm).subscribe((data) => {
        this.loader.stop();
        this.$emit('save');
      }, onError);
    } else {
      let observable = null;
      if (this.alterUnitOnly) {
        let payload = new LoginUnidadesParmDTO();
        payload.idLogin = Number(this.item.id);
        payload.idsUnidades = this.item.idsUnidadesClientes;
        observable = service.alterUnitUser(payload);
      } else {
        observable = service.updateUser(parm);
      }

      observable.subscribe((data) => {
        this.loader.stop();
        getLocalUser().subscribe((currentUser) => {
          if (this.item.id === currentUser.idLogin) {
            window.location.reload();
          } else {
            this.$emit('save');
          }
        });
      }, onError);
    }
  }

  public closeForm(): void {
    const closeAction = () => {
      if (this.activationSaved) {
        this.$emit('save');
      } else {
        this.$emit('close');
      }
    };

    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      closeAction
    );
  }

  private getProfiles(): void {
    this.profilesLoading = true;
    service.listUserProfiles(this.item.tipoAcesso).subscribe((data) => {
      this.profiles = data;
      this.profilesLoading = false;
      if (!!this.item.idPerfil) {
        if (this.profiles.findIndex(p => p.id == this.item.idPerfil) == -1) {
          this.item.idPerfil = null;
        }
      }
    }, error => {
      this.showToastApiError(error);
      this.profilesLoading = false;
    });
  }

  private getUserTypes(): void {
    this.userTypesLoading = true;
    service.listUserLoginTypes().subscribe((data) => {
      this.userTypes = data;
      this.userTypesLoading = false;
      if (data.length == 1) {
        this.item.tipoLogin = data[0].id;
      }
    }, error => {
      this.showToastApiError(error);
      this.userTypesLoading = false;
    });
  }

  private getDoctors(): void {
    this.doctorLoading = true;
    getDoctors({ status: true }).subscribe(
      (data) => {
        this.doctors = data;
        this.doctorLoading = false;
      },
      () => {
        this.doctorLoading = false;
      }
    );
  }

  private getUnits(): void {
    getBusinessUnitsUser().subscribe((data) => {
      this.units = data;
    });
  }

  public onChangeStatus(): void {
    if (!this.item || !this.item.id) {
      return;
    }
    this.activationUserId = this.item.id;
    this.showActivationModal = true;

    setTimeout(() => {
      this.item.ativo = !this.item.ativo;
    }, 100);
  }

  public onCloseActivationModal() {
    this.activationUserId = null;
    this.showActivationModal = false;
  }

  private onAfterSaveActivation(dto) {
    this.activationSaved = true;
    this.onCloseActivationModal();
    this.item.ativo = dto.ativo;
    this.item.motivoInativacao = dto.motivoInativacao;
  }

  private onChangeUnidadesEmpresariais() {
    this.loadLeaders();
    this.loadGeoAreas();
  }

  loadLeaders() {
    let idsBu = this.item.idsEmpresas;
    this.leaders = [];
    if (!idsBu || !idsBu.length || !this.isLeadersChoiceAvailable()) {
      this.item.lideres = [];
      return;
    }
    this.leadersLoading = true;
    service.listLeaders(this.item.id ? Number(this.item.id) : null, idsBu).subscribe(
      (res) => {
        this.leaders = res;
        this.leadersLoading = false;
        let idsLideresAtuais = Array.from(this.item.lideres ? this.item.lideres.map((l) => l.id) : []);
        this.item.lideres = res.filter((l) => idsLideresAtuais.indexOf(l.id) != -1);
      },
      (error) => {
        this.showToastApiError(error);
        this.leadersLoading = false;
      }
    );
  }

  isLeadersChoiceAvailable() {
    return this.item.tipoAcesso != ACCESS_TYPE_CLIENT && this.item.tipoLogin == USER_TYPE_OTHER;
  }

  loadGeoAreas() {
    this.geoAreasLoading = true;
    let idsBu = this.item.idsEmpresas;
    service.listGeoAreas(idsBu).subscribe(
      (res) => {
        this.geoAreas = res;
        this.geoAreasLoading = false;
      },
      (error) => {
        this.geoAreasLoading = false;
      }
    );
  }
}
